
<template>
	<div class="product-carousel">
		<swiper class="swiper product-carousel-swiper" :options="swiperOptionTop" ref="swiperTop">
			<swiper-slide v-for="image in images" :key="image.id">
				<img :src="image.url" class="img-fluid" alt="">
			</swiper-slide>
			<div class="swiper-button-next swiper-button-black" slot="button-next"></div>
			<div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
		</swiper>
		<swiper v-if="images.length > 1" class="swiper product-carousel-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
			<swiper-slide v-for="image in images" :key="image.id">
				<img :src="image.url" class="img-fluid" alt="">
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
	import 'swiper/css/swiper.css'

	export default {
		name: 'swiper-example-thumbs-gallery',
		title: 'Thumbs gallery with Two-way control',
		components: {
			Swiper,
			SwiperSlide
		},
		props: {
			images: {
				type: Array, // {id: Number, url: String}
				required: true,
			}
		},
		data() {
			return {
				swiperOptionTop: {
					loop: true,
					loopedSlides: 5, // looped slides should be the same
					spaceBetween: 10,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
          autoHeight: true,
				},
				swiperOptionThumbs: {
					loop: true,
					loopedSlides: 5, // looped slides should be the same
					spaceBetween: 10,
					// centeredSlides: true,
					slidesPerView: 'auto',
					touchRatio: 0.2,
					slideToClickedSlide: true,
          // centerInsufficientSlides: true,
				}
			}
		},
		mounted() {
			this.$nextTick(() => {
				const swiperTop = this.$refs.swiperTop.$swiper
				const swiperThumbs = this.$refs.swiperThumbs.$swiper
        // swiperTop.on('slideChange', function() {
        //   if (swiperThumbs.realIndex !== this.realIndex) {
        //     swiperThumbs.slideTo(this.realIndex);
        //   }
        // })
        // swiperThumbs.on('slideChange', function() {
        //   if (swiperTop.realIndex !== this.realIndex) {
        //     swiperTop.slideTo(this.realIndex);
        //   }
        // })
        //
        // swiperThumbs.on('click', function() {
        //   console.log( this )
        // })
				swiperTop.controller.control = swiperThumbs
				swiperThumbs.controller.control = swiperTop
			})
		}
	}
</script>

<style lang="scss">
	.swiper {
		&.product-carousel-swiper {
			height: 80%;
			width: 100%;
		}
		&.product-carousel-thumbs {
			height: 20%;
			box-sizing: border-box;
			padding: 10px 0;

      img:hover {
        cursor: pointer;
      }
		}
		&.product-carousel-thumbs .swiper-slide {
			width: 25%;
			height: 100%;
			opacity: 0.4;
		}
		&.product-carousel-thumbs .swiper-slide-active {
			opacity: 1;
		}

		.swiper-button-disabled {
			display: none;
		}
	}
</style>